export enum PRINCIPAL_TYPE {
	GROUP = 'group',
	USER = 'user',
	TEAM = 'team',
	EMAIL = 'email',
}

export type SpaceAccessDetailsParamsType = {
	restrictingContentId?: string | null;
	spaceKey: string;
	hasInheritedRestrictions: boolean;
	experience: string;
};
